import { isString, toNumber } from 'lodash'
import { conformToMask, createNumberMask } from './inputMasks'

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export const mask = createNumberMask({
  allowDecimal: true,
  integerLimit: 13,
  allowLeadingZeroes: true,
}) as (value: string) => (string | RegExp)[]

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export const noDecimalMask = createNumberMask({
  allowDecimal: false,
  integerLimit: 13,
}) as (value: string) => (string | RegExp)[]

export const normalize = (string: string): string => {
  if (!string) {
    return string
  }
  let padded: string
  if (string.includes('.')) {
    padded = /\d\./.test(string)
      ? `${string}00`
      : `${string.replace('.', '0.')}00`
  } else {
    padded = `${string}.00`
  }
  return conformToMask(padded, mask, { guide: false }).conformedValue
}

/**
 * This function simply strips special characters from a string that should contain a number, i.e. '$123,230,283.54'
 * Then round the number with decimal to remove the decimal. It should technically never be possible since the corresponding numberMask
 * won't allow decimals. This also doesn't cover the possibility that we pre-populate the field from state with decimal as the mask will simply remove the decimal
 * and turn 123.23 into 12323.
 */
export const normalizeNoDecimal = (string: string): string => {
  if (!string) {
    return string
  }
  let padded: string | null = null
  if (string.includes('.')) {
    // regex to replace special characters in string first, then round it
    padded = string.replace(/[^0-9.]/g, '')
    padded = Math.round(Number(padded)).toString()
  }

  return conformToMask(padded || string, noDecimalMask, { guide: false })
    .conformedValue
}

export const stringify = (apiValue: number): string => {
  if (Number.isFinite(apiValue)) {
    return normalize(apiValue.toString())
  } else {
    return ''
  }
}

export const parse = (uiValue: string): number => {
  if (isString(uiValue) && uiValue.length) {
    const numberCharacters = uiValue.match(/[\d.]/g) || []
    return toNumber(numberCharacters.join(''))
  }
  return 0
}
